/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import Range from 'rc-slider';
import 'rc-slider/assets/index.css';
import { FilterGroup, FilterLabel } from '@lt/components';

import classNames from 'classnames';
import styles from './FilterSlider.module.css';
import type { FilterSliderProps } from './types';
import { convertToMinutes, minutesToTimeFormat } from './utils';

export const FilterSlider = ({
  data,
  Filter,
  isMobile,
  minPrice,
  onChange,
  onClear,
}: FilterSliderProps) => {
  const {
    time_from = '00:00',
    time_to = '23:59',
    selected_time_from,
    selected_time_to,
    suitable_flights,
  } = data;

  const [stringRange, setStringRange] = useState({
    rangeTimeFrom: selected_time_from ?? time_from,
    rangeTimeTo: selected_time_to ?? time_to,
  });

  const [showClearBtn, setShowClearBtn] = useState(false);

  const handleChangeRange = (newValue) => {
    setStringRange({
      rangeTimeFrom: minutesToTimeFormat(newValue[0]),
      rangeTimeTo: minutesToTimeFormat(newValue[1]),
    });
    setShowClearBtn(true);
  };

  const handleChange = () => {
    onChange({
      path: Filter.filterName,
      selected_time_from: stringRange.rangeTimeFrom,
      selected_time_to: stringRange.rangeTimeTo,
    });
  };

  const handleClear = () => {
    onClear(Filter.filterName);
    setShowClearBtn(false);
    setStringRange({
      rangeTimeFrom: time_from,
      rangeTimeTo: time_to,
    });
  };

  useEffect(() => {
    if (!selected_time_from || !selected_time_to)
      setStringRange({ rangeTimeFrom: time_from, rangeTimeTo: time_to });
  }, [time_from, time_to]);

  return (
    <FilterGroup
      label={Filter.filterLabel}
      isCollapsible={!isMobile}
      isMobile={isMobile}
      showClearBtn={showClearBtn}
      isClearButtonInline
      onClear={handleClear}
    >
      <FilterLabel
        isMobile={isMobile}
        count={suitable_flights}
        price={minPrice}
        name={`${stringRange.rangeTimeFrom} - ${stringRange.rangeTimeTo}`}
        className={classNames(styles.label, { [styles.labelMobile]: isMobile })}
      />
      <div
        className={classNames(styles.trackContainer, {
          [styles.trackContainerMobile]: isMobile,
        })}
      >
        <Range
          min={convertToMinutes(time_from)}
          max={convertToMinutes(time_to)}
          value={[
            convertToMinutes(stringRange.rangeTimeFrom),
            convertToMinutes(stringRange.rangeTimeTo),
          ]}
          range={{ minCount: 2 }}
          allowCross={false}
          onChange={handleChangeRange}
          onChangeComplete={handleChange}
          styles={{
            rail: {
              backgroundColor: '#FFE6DD',
              height: 2,
            },
            track: { backgroundColor: 'var(--secondary)', height: 2 },
            handle: {
              backgroundColor: 'var(--secondary)',
              borderColor: 'var(--secondary)',
              width: 16,
              height: 16,
              marginTop: '-7px',
              opacity: 1,
              boxShadow: 'none',
              border: 'none',
              zIndex: 0,
            },
          }}
          dotStyle={{ width: '0px', height: '0px', borderColor: 'none' }}
        />
      </div>
    </FilterGroup>
  );
};
